import { render, staticRenderFns } from "./PersonalDataPollComponent.vue?vue&type=template&id=47ffcd96&"
import script from "./PersonalDataPollComponent.vue?vue&type=script&lang=js&"
export * from "./PersonalDataPollComponent.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDataPollComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports